module.exports = __webpack_public_path__ + "img/Republic-of-Artsakh.610a86da.png";